import { render } from "./audio.vue?vue&type=template&id=6d8d29e4&scoped=true"
import script from "./audio.vue?vue&type=script&lang=js"
export * from "./audio.vue?vue&type=script&lang=js"

import "./audio.vue?vue&type=style&index=0&id=6d8d29e4&lang=less&scoped=true"

import exportComponent from "D:\\codeDevelopment\\文稿通\\wgt_user_web_2.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8d29e4"]])

export default __exports__